import React from 'react';
import { AuthPageWrapper } from 'features/authentication/auth-page-wrapper/auth-page-wrapper';
import { Heading, MenuText, DevicesIllustration, Link } from '@placer-ui/components';
import { useQuery } from 'hooks/use-query/use-query';
import styles from './email-mfa.module.scss';

export const EmailMfaBounced = () => {
    const email = useQuery('email')!;

    return (
        <AuthPageWrapper>
            <div className={styles.container}>
                <DevicesIllustration/>
                <div className={styles.textContainer}>
                    <div className={styles.headingContainer}>
                        <Heading variant={'h2'}>Couldn’t Verify Your Identity</Heading>
                    </div>
                    <MenuText>We were unable to deliver the verification email to {email}.</MenuText>
                    <MenuText element={'p'}>Please reach out to <Link href="mailto:support@placer.ai">support@placer.ai</Link> to verify your account.</MenuText>
                </div>
            </div>
        </AuthPageWrapper>
    );
};
